export namespace Define {

    export enum RequestKindDef {
        Arrive = 1,
        Leave,
        TemporaryLeave,
        Reenter,
        CancelTemporaryLeave = 13,
        CancelReenter,
    }

    export const RequestKinds = [
        { id: RequestKindDef.Arrive as number, value: '出社' },
        { id: RequestKindDef.Leave as number, value: '退社' },
        { id: RequestKindDef.TemporaryLeave as number, value: '外出' },
        { id: RequestKindDef.Reenter as number, value: '戻り' },
        { id: RequestKindDef.CancelTemporaryLeave as number, value: '外出取消' },
        { id: RequestKindDef.CancelReenter as number, value: '戻り取消' },
    ];

    export enum RequestState {
        Registered = 0,
        Approve,
        Reject,
    }

    export enum Authority {
        Normal = 0,
        Approver = 1,
        Manager = 2,
    }

    export const AuthorityName = [
        { id: Authority.Normal as number, value: '一般' },
        { id: Authority.Approver as number, value: '承認者' },
        { id: Authority.Manager as number, value: '管理職' },
    ];


    export enum ManageAuthority {
        None = 0,
        Maintener = 11,
        Administrator = 99,
    }

    export const ManageAuthorityName = [
        { id: ManageAuthority.None as number, value: '無し' },
        { id: ManageAuthority.Maintener as number, value: '事務担当' },
        { id: ManageAuthority.Administrator as number, value: '管理者' },
    ];

    export enum closingDay{
        Undefined = 0,
        DayOf10 = 10,
        DayOf15 = 15,
        DayOf20 = 20,
        DayOf25 = 25,
        EndOfMonth = 31,
    }

    export const closingDaysList = [
        {id: closingDay.DayOf10 as number , value: '10日'},
        {id: closingDay.DayOf15 as number , value: '15日'},
        {id: closingDay.DayOf20 as number , value: '20日'},
        {id: closingDay.DayOf25 as number , value: '25日'},
        {id: closingDay.EndOfMonth as number , value: '月末'},
    ];

    export enum UserField {
      Id = 0,
      Name,
      Kana,
      Team,
    }
}
